import { useEffect, useState } from 'react';

import sadFaceIcon from '../../../../../assets/images/sad_face-icon.png';
import checkIcon from '../../../../../assets/svgs/check-icon.svg';
import Dialog from '../../../../../components/Dialog';
import { CustomIcon } from '../../../../../components/widgets/CustomIcon';
import { api } from '../../../../../services/api';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { NotificationToggleProps } from '../types/notificationTypes';
import { Toast } from './Toast';

const apiNotificacoes = apiSensedia;

// if (process.env.NODE_ENV != 'development') {
//   apiNotificacoes = apiSensedia;
// }

export const NotificationToggle = ({
  isLoading,
  isLoadingSwitch,
  title,
  complement,
  data,
  email,
  showToast,
  setEmail,
  onSwitchChange,
  handleShowToast,
  getConfigurations
}: NotificationToggleProps) => {
  const [errorAlert, setErrorAlert] = useState(false);
  const [confirmAlert, setConfirmAlert] = useState(false);

  const [isOpenModal, setIsOpenModal] = useState(false);

  const disableButton = email === '' || confirmAlert;

  const handleChangeEmail = (email: string) => {
    setErrorAlert(false);
    setConfirmAlert(false);
    setEmail(email);
  };

  const handleSubmitEmail = async () => {
    const body = {
      email: {
        valor: email
      }
    };

    if (email.includes('@')) {
      try {
        const response = await apiNotificacoes.post(
          `notificacoes/contatos`,
          body
        );

        setIsOpenModal(true);
        setConfirmAlert(true);
        getConfigurations(true);
      } catch (error) {
        console.log(error);
      }
    } else {
      setErrorAlert(true);
    }
  };

  return !isLoading && data?.length > 1 ? (
    <div className="tw-bg-white tw-text-[#001E64] tw-shadow-[0px_0px_5px_rgba(50,50,50,0.25)] tw-rounded-xl tw-p-5 tw-flex tw-flex-col tw-gap-3 tw-text-base">
      <span className="tw-flex tw-flex-col  md:tw-flex-row tw-gap-2 tw-font-bold tw-items-center">
        <h2 className="tw-text-[#323232] tw-text-[1.25rem]">{title}</h2>
        <p>{complement}</p>
      </span>
      {title.includes('e-mail') && (
        <div className="tw-bg-[#F4F4F4] tw-rounded-md tw-p-5">
          <span className="tw-flex tw-flex-col  md:tw-flex-row tw-gap-2">
            <h2 className="tw-text-[#323232] tw-font-bold">E-mail</h2>
            <p className="tw-text-[0.875rem]">
              (Por favor, insira o seu endereço de e-mail para receber esta
              notificação.)
            </p>
          </span>
          <span className="tw-flex tw-gap-6 tw-mt-2">
            <div className="tw-flex tw-flex-col tw-w-[65%] tw-gap-2 tw-relative">
              <input
                className="tw-h-12 tw-px-5"
                placeholder="E-mail"
                value={email}
                onChange={(e) => handleChangeEmail(e.target.value)}
              />
              <span
                style={{ display: confirmAlert ? 'flex' : 'none' }}
                className="tw-text-[#146CFA] tw-font-bold tw-absolute tw-right-3 tw-top-3 tw-cursor-pointer"
                onClick={handleSubmitEmail}
              >
                reenviar e-mail
              </span>
              <span
                style={{ display: errorAlert ? 'flex' : 'none' }}
                className="tw-text-[#AA2C23] tw-font-bold"
              >
                e-mail inválido
              </span>
              <span
                style={{ display: confirmAlert ? 'flex' : 'none' }}
                className="tw-text-[#FF5000] tw-font-bold"
              >
                Confirmação pendente. Confirme em até 24hrs
              </span>
            </div>
            <button
              disabled={disableButton}
              style={{
                cursor: disableButton ? 'not-allowed' : 'pointer',
                background: disableButton ? '#828282' : '#001E64'
              }}
              className="tw-px-12 tw-bg-[] tw-text-white tw-font-bold tw-rounded-full tw-max-h-12"
              onClick={handleSubmitEmail}
            >
              Salvar
            </button>
          </span>
        </div>
      )}
      <hr className="tw-my-4 tw-mx-[-1.25rem]" />
      {data?.map((item, index) => (
        <div
          key={index}
          style={{
            background: index % 2 ? '#D3DEED' : '#F4F4F4'
          }}
          className="tw-border-l-4 tw-border-[#FF5000] tw-rounded-lg tw-p-3 md:tw-py-4 md:tw-px-5 tw-flex tw-justify-between tw-items-center"
        >
          <p className="tw-max-w-[12rem] md:tw-max-w-full">{item?.label}</p>
          <div className="tw-relative">
            {isLoadingSwitch === item?.id ? (
              <div
                style={{ borderTopColor: 'transparent' }}
                className="tw-w-8 tw-h-8 tw-border-4 tw-border-[#001E64] tw-border-solid tw-rounded-full tw-animate-spin"
              ></div>
            ) : (
              <button
                className="tw-bg-transparent"
                onClick={() => onSwitchChange(item?.id, !item?.checked)}
              >
                <div
                  className={`tw-w-11 tw-h-4  tw-rounded-full tw-shadow-inner ${
                    item?.checked ? 'tw-bg-[#757dbb6b]' : 'tw-bg-gray-400'
                  }`}
                ></div>
                <div
                  className={`tw-absolute tw-w-6 tw-h-6 tw-rounded-full tw-shadow tw-inset-y-0 tw-top-[-0.25rem] tw-left-0 ${
                    item?.checked
                      ? 'tw-bg-[#001E64] tw-left-[1.5rem]'
                      : 'tw-bg-white'
                  }`}
                ></div>
              </button>
            )}
          </div>
        </div>
      ))}
      <Dialog
        isOpen={isOpenModal}
        title={''}
        description={''}
        setIsOpen={setIsOpenModal}
      >
        <div className="tw-w-[100%] tw-flex tw-flex-col tw-items-center">
          <CustomIcon src={checkIcon} width={49} height={49} />
          <h2 className="tw-text-[#006217] tw-font-bold tw-text-[1.5rem] tw-mt-5">
            E-mail enviado com sucesso!
          </h2>
          <div className="tw-text-center tw-text-[#323232]">
            <p>
              Por favor, acesse o seu e-mail cadastrado&nbsp;
              <strong>{`(${email})`}</strong> para validar.&nbsp;
              <strong>Verifique sua caixa de entrada ou spam.</strong>
            </p>
          </div>
        </div>
      </Dialog>
      {showToast && (
        <Toast
          typeMessage={'error'}
          message={'Aguardando confirmação do e-mail'}
          onClose={handleShowToast}
        />
      )}
    </div>
  ) : (!isLoading && data?.length < 1) || (!isLoading && !data) ? (
    <div className="tw-bg-white tw-text-[#001E64] tw-shadow-[0px_0px_5px_rgba(50,50,50,0.25)] tw-rounded-xl tw-p-10 tw-flex tw-flex-col tw-gap-3 tw-text-base">
      <div className="tw-flex tw-flex-col tw-gap-7 tw-justify-center tw-items-center">
        <img src={sadFaceIcon} alt="sad-face" width={75} height={75} />
        <p className="tw-text-[#AAA]">
          Parece que você não tem nenhuma configuração.
        </p>
      </div>
    </div>
  ) : (
    <div className="tw-bg-white text-[#001E64] tw-shadow-[0px_0px_5px_rgba(50,50,50,0.25)] tw-rounded-xl tw-p-16">
      <div className="tw-flex tw-flex-col tw-gap-7 tw-justify-center tw-items-center">
        <div
          style={{ borderTopColor: 'transparent' }}
          className="tw-w-20 tw-h-20 tw-border-4 tw-border-[#001E64] tw-border-solid tw-rounded-full tw-animate-spin"
        ></div>
      </div>
    </div>
  );
};
